import { Tab, Tabs } from "@material-ui/core";
import "core-js/es6/object";
import { map } from "ramda";
import * as React from "react";
import { connect } from "react-redux";
import { match } from "react-router";
import { getUserId } from "src/login/selector";
import LoadingSpinner from "src/shared/LoadingSpinner";
import {
  getComments,
  getSpreadId,
  getSpreadName
} from "src/spread/model/spread/selector";
import { State } from "src/state";
import {
  addUserToReadByForComments,
  AddUserToReadByForCommentsType,
  getComments as getCommentsAction,
  GetCommentsActionType
} from "./actions";
import CommentCard from "./CommentCard";
import "./CommentView.scss";
import {
  getSpreadComments,
  getUnreadComments,
  sortCommentsByAccount
} from "./helpers";
import { AccountComments, Comment } from "./types";

interface CommentViewState {
  activeTab: number;
  spreadComments: Comment[] | null;
  sortedAccountComments: AccountComments | null;
  newCommentText: string;
  loading: boolean;
}

interface CommentViewProps {
  match: match<{ id: string; environmentName?: string; status?: string }>;
  userId: string;
  spreadName: string;
  spreadId: string;
  getComments: GetCommentsActionType;
  addUserToReadByForComments: AddUserToReadByForCommentsType;
  comments: Comment[];
}

export class CommentView extends React.Component<
  CommentViewProps,
  CommentViewState
> {
  constructor(props: CommentViewProps) {
    super(props);
    this.state = {
      activeTab: 0,
      spreadComments: null,
      sortedAccountComments: null,
      newCommentText: "",
      loading: true
    };
  }

  public componentDidMount() {
    this.props.getComments(this.props.match.params.id);
  }

  public componentDidUpdate(prevProps) {
    const { comments } = this.props;
    if (comments !== prevProps.comments) {
      const spreadComments = getSpreadComments(comments);
      const sortedAccountComments = sortCommentsByAccount(comments);

      this.setState({ spreadComments, sortedAccountComments, loading: false });

      const unreadComments = getUnreadComments(comments, this.props.userId);
      if (unreadComments.length > 0) {
        this.markCommentsAsRead(unreadComments);
      }
    }
  }

  public render() {
    const { activeTab } = this.state;

    return (
      <div className="Comment__container">
        <div className="Comment__header__container">
          <div className="Comment__header">
            <div className="Comment__header__title">
              {this.props.spreadName}
            </div>
          </div>
          <Tabs
            className="Comment__tabs"
            value={activeTab}
            onChange={this.handleTabChange}
            classes={{ indicator: "Comment__tabs__indicator" }}
          >
            <Tab
              className="Comment__tabs__tab"
              label="ALL COMMENTS"
              classes={{
                labelContainer: "Comment__tabs__tab__label",
                selected: "Comment__tabs__tab--selected"
              }}
              disableRipple={true}
            />
            <Tab
              className="Comment__tabs__tab"
              label="SPREAD COMMENTS"
              classes={{
                labelContainer: "Comment__tabs__tab__label",
                selected: "Comment__tabs__tab--selected"
              }}
              disableRipple={true}
            />
            <Tab
              className="Comment__tabs__tab"
              label="ACCOUNT COMMENTS"
              classes={{
                labelContainer: "Comment__tabs__tab__label",
                selected: "Comment__tabs__tab--selected"
              }}
              disableRipple={true}
            />
          </Tabs>
        </div>
        <div className="Comment__content">
          {activeTab === 0 && this.renderAllComments()}
          {activeTab === 1 && this.renderSpreadComments()}
          {activeTab === 2 && this.renderAccountComments()}
        </div>
      </div>
    );
  }

  public handleTabChange = (event: object, newValue: number) => {
    this.setState({ activeTab: newValue });
  };

  private renderSpreadComments = () => {
    const { spreadComments, loading } = this.state;
    if (loading || spreadComments === null) {
      return <LoadingSpinner />;
    }

    if (spreadComments && Object.keys(spreadComments).length < 1) {
      return <span>There are no spread comments for this spread...</span>;
    }

    return (
      <div className="Comment__content__cards">
        {map(
          (comment: Comment) => (
            <CommentCard comment={comment} key={comment.id} />
          ),
          spreadComments
        )}
      </div>
    );
  };

  private renderAccountComments = () => {
    const { sortedAccountComments } = this.state;

    if (sortedAccountComments === null) {
      return <LoadingSpinner />;
    }

    if (Object.keys(sortedAccountComments).length < 1) {
      return <span>There are no account comments for this spread...</span>;
    }

    return Object.keys(sortedAccountComments).map(
      (key: string, index: number) =>
        this.renderCommentsBySection(sortedAccountComments[key], index)
    );
  };

  private renderAllComments = () => {
    const { spreadComments, sortedAccountComments } = this.state;
    if (spreadComments === null || sortedAccountComments === null) {
      return <LoadingSpinner />;
    }

    if (
      Object.keys(spreadComments).length < 1 &&
      Object.keys(sortedAccountComments).length < 1
    ) {
      return <span>There are no comments for this spread...</span>;
    }

    return (
      <div>
        {this.renderCommentsBySection(spreadComments, 0)}

        {Object.keys(sortedAccountComments).map(
          (key: string, index: number) => {
            const comments = this.state.sortedAccountComments
              ? this.state.sortedAccountComments[key]
              : [];
            return this.renderCommentsBySection(comments, index + 1);
          }
        )}
      </div>
    );
  };

  private renderCommentsBySection = (comments: Comment[], index: number) => {
    return (
      <div
        className="Comment__content__cards Comment__content__cards--section"
        key={index}
      >
        {map(
          (comment: Comment) => (
            <CommentCard comment={comment} key={comment.id} />
          ),
          comments
        )}
      </div>
    );
  };

  private markCommentsAsRead = (unreadComments: Comment[]) => {
    this.props.addUserToReadByForComments({
      comments: unreadComments,
      userId: this.props.userId
    });
  };
}

const mapStateToProps = (state: State) => ({
  spreadName: getSpreadName(state),
  userId: getUserId(state),
  spreadId: getSpreadId(state),
  comments: getComments(state)
});

export default connect(
  mapStateToProps,
  {
    getComments: getCommentsAction.action,
    addUserToReadByForComments: addUserToReadByForComments.action
  }
)(CommentView);



// WEBPACK FOOTER //
// ./src/commentView/CommentView.tsx